(() => {
  'use strict';
  if (window.fellauraShippingInitialized) return;
  window.fellauraShippingInitialized = true;
  const selector = '[data-fellaura-shipping]';
  const eastern = new Intl.DateTimeFormat('en-US', {timeZone:'America/New_York', year:'numeric', month:'numeric', day:'numeric'});
  const short = new Intl.DateTimeFormat('en-US', {timeZone:'UTC', month:'short', day:'numeric'});
  let anchor = null, pending = false;
  const calendar = (d, n) => new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + n));
  const businessDate = (date, days) => {
    let result = calendar(date, 0);
    while (days > 0) {
      result = calendar(result, 1);
      if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) days--;
    }
    return result;
  };
  const range = (a, b) => a.getUTCMonth() === b.getUTCMonth() && a.getUTCFullYear() === b.getUTCFullYear() ? short.format(a) + '–' + b.getUTCDate() : short.format(a) + '–' + short.format(b);
  function render() {
    let today = null;
    if (anchor && performance.now() - anchor.tick < 180000) {
      const parts = Object.fromEntries(eastern.formatToParts(new Date(anchor.ms + performance.now() - anchor.tick)).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
      today = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
    }
    document.querySelectorAll(selector).forEach(root => {
      const ordered = root.querySelector('[data-delivery-date="ordered"]');
      const ready = root.querySelector('[data-delivery-date="ready"]');
      if (ordered) ordered.textContent = today ? short.format(today) : '—';
      const delivery = root.querySelector('[data-delivery-date="delivery"]');
      const origin = root.dataset.origin;
      const known = origin === 'usa' || origin === 'overseas';
      const pendingText = root.dataset.pending || '—';
      if (ready) ready.textContent = today && known ? range(businessDate(today, origin === 'usa' ? 1 : 2), businessDate(today, origin === 'usa' ? 2 : 3)) : pendingText;
      if (delivery) delivery.textContent = today && known ? range(businessDate(today, origin === 'usa' ? 2 : 5), businessDate(today, origin === 'usa' ? 5 : 10)) : pendingText;
    });
  }
  async function sync() {
    const root = document.querySelector(selector);
    if (!root || pending || document.hidden) return;
    pending = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    const start = performance.now();
    try {
      const response = await fetch(root.dataset.clockUrl, {method:'HEAD', cache:'no-store', credentials:'same-origin', signal:controller.signal});
      const ms = Date.parse(response.headers.get('Date') || '');
      const age = Number(response.headers.get('Age') || 0);
      const elapsed = performance.now() - start;
      if (!response.ok || !Number.isFinite(ms) || !Number.isFinite(age) || age < 0 || age > 30 || elapsed > 8000) throw new Error('Clock unavailable');
      anchor = {ms:ms + age * 1000 + elapsed / 2, tick:performance.now()};
    } catch (_) {
      if (anchor && performance.now() - anchor.tick >= 180000) anchor = null;
    }
    finally { clearTimeout(timeout); pending = false; render(); }
  }
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { render(); sync(); } });
  window.addEventListener('pageshow', sync);
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('variant:change', render);
  document.addEventListener('change', event => { if (event.target.matches('[name="id"], [name^="options"]')) render(); });
  setInterval(() => { if (!document.hidden) render(); }, 1000);
  setInterval(sync, 60000);
  render(); sync();
})();
